import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { IObservationStats } from './IObservationStats'
import { TimeRangeProjectAnalytics } from '../TimeRangeProjectAnalytics'
import { ObservationStatsTasks } from './ObservationStatsTasks'

export class ObservationStats extends Entity<IObservationStats> {
  @Type(() => TimeRangeProjectAnalytics)
  lastSevenDays: TimeRangeProjectAnalytics

  @Type(() => ObservationStatsTasks)
  tasks: ObservationStatsTasks

  public static new(payload: unknown): ObservationStats {
    const entity = plainToInstance(ObservationStats, payload)

    return entity
  }
}
